module.exports = __webpack_public_path__ + "img/horizontal_3_5_9006.b267a6cd.png";